import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { userIdentityShape, routerShape } from '@bibliocommons/bc-prop-types';

import { FILTER_PREFIX, FILTER_SEPARATOR, FACET_FIELDS_ORDER } from 'app/constants/BibConstants';
import shelfShape from 'app/shapes/shelves/shelfShape';
import FieldList from '../../deprecated/shared/Facets/FieldList';

export class ShelfFacets extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleExpandField(fieldId) {
    const { owner, shelf, router } = this.props;
    this.props.shelfActions.fetchAdditionalFilters(shelf.get('name'), owner.get('id'), fieldId, router.query);
  }

  render() {
    const { activeFilters, shelf, drawerActions } = this.props;

    return (
      <div className="cp-shelf-facets">
        <FieldList
          separator={FILTER_SEPARATOR}
          prefix={FILTER_PREFIX}
          fieldsOrder={FACET_FIELDS_ORDER}
          fields={shelf.get('facets')}
          drawerActions={drawerActions}
          activeFilters={activeFilters}
          handleExpandField={this.handleExpandField}
        />
      </div>
    );
  }
}

ShelfFacets.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  shelf: shelfShape.isRequired,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  router: routerShape.isRequired
};

export default withRouter(ShelfFacets);
